import controller from './filter-module-range-controller';

const FilterModuleRangeComponent: angular.IComponentOptions = {
  controller,
  controllerAs: 'ctrl',
  bindings: {
    key: '<',
    filter: '<',
    filterOpts: '<',
    onSelection: '&?',
  },
  template: `
    <div class="filter-module-range">
      <div class="field-group number" ng-if="ctrl.isNumber">
        <input
          type="number"
          class="form-control form-control-sm range-filter-input range-min"
          step="any"
          ng-model="ctrl.min"
          placeholder="{{ctrl.options.min}}"
          ng-focus="ctrl.onFocusInput($event)"
        />
        <span class="range-separator">&ndash;</span>
        <input
          type="number"
          class="form-control form-control-sm range-filter-input range-max"
          step="any"
          ng-model="ctrl.max"
          placeholder="{{ctrl.options.max}}"
          ng-focus="ctrl.onFocusInput($event)"
        />
      </div>
      <div class="field-group date" ng-if="ctrl.isDate">
        <input
          type="text"
          mode-date-picker="{{ ctrl.minDateString }}"
          adjust-for-timezone="true"
          on-change="ctrl.setMinDate($value)"
          ng-click="ctrl.onFocusInput($event)"
          placeholder="{{ ctrl.minDatePlaceholder }}"
          id="{{ ctrl.filter.position }}-min"
          name="{{ ctrl.filter.position }}-min"
          class="form-control form-control-sm range-filter-input range-min" />
        <span class="range-separator">&ndash;</span>
        <input
          type="text"
          mode-date-picker="{{ ctrl.maxDateString }}"
          adjust-for-timezone="true"
          on-change="ctrl.setMaxDate($value)"
          ng-click="ctrl.onFocusInput($event)"
          placeholder="{{ ctrl.maxDatePlaceholder }}"
          id="{{ ctrl.filter.position }}-max"
          name="{{ ctrl.filter.position }}-max"
          class="form-control form-control-sm range-filter-input range-max" />
      </div>
      <div class="field-group date" ng-if="ctrl.isDiscreteDate">
        <select
          class="form-control form-control-sm range-filter-input"
          ng-model="ctrl.minDiscreteDate"
        >
          <option
            ng-repeat="option in ctrl.discreteDateOptions"
            value="{{option.value}}"
          >{{option.label}}</option>
        </select>
        <span class="range-separator">&ndash;</span>
        <select
          class="form-control form-control-sm range-filter-input"
          ng-model="ctrl.maxDiscreteDate"
        >
          <option
            ng-repeat="option in ctrl.discreteDateOptions"
            value="{{option.value}}"
          >{{option.label}}</option>
        </select>
      </div>
    </div>
  `,
};

export { FilterModuleRangeComponent };
